import { root_modal_state } from './root_modal_state.svelte';
import { cap_utils } from '../cap_utils';
import { utils } from "../utils.svelte";


type PeromissionEntry = {
   is_granted: boolean;
   attempted: boolean;

};
export type PermissionsState = {
   push_notifications_permission: PeromissionEntry
   mic_permission: PeromissionEntry;
   location_permission: PeromissionEntry;
};

function permissions_state_fn() {
   const permissions_rune = utils.states.create_persisted<PermissionsState>({
      key: 'permissions_state',
      initial_value: {
         push_notifications_permission: { is_granted: false, attempted: false },
         mic_permission: { is_granted: false, attempted: false },
         location_permission: { is_granted: false, attempted: false }
      },
   });

   // const { permissions_rune.value.location_permission } = permissions_rune;
   const handlers = {

      update_push_notifications_permission: (new_value: boolean | PeromissionEntry) => {
         if (typeof new_value === 'boolean') permissions_rune.value.push_notifications_permission = { is_granted: new_value, attempted: true }
         else permissions_rune.value.push_notifications_permission = new_value
         if (new_value === false) import('./push_notifications').then(({ push_notifications_state }) => push_notifications_state.reset()).catch(console.error)
         permissions_rune.persist_current_state()
      },

      update_mic_permission: (new_value: boolean | PeromissionEntry) => {
         if (typeof new_value === 'boolean') permissions_rune.value.mic_permission = { is_granted: new_value, attempted: true }
         else permissions_rune.value.mic_permission = new_value
         permissions_rune.persist_current_state()
      },

      update_location_permission: (new_value: boolean | PeromissionEntry) => {
         if (typeof new_value === 'boolean') permissions_rune.value.location_permission = { is_granted: new_value, attempted: true }
         else permissions_rune.value.location_permission = new_value
         permissions_rune.persist_current_state()
      },

      async init_permissions() {

         const { push_notifications_state } = await import('./push_notifications');
         const device_os = await cap_utils.device.get_device_os()

         switch (device_os) {
            case 'ios': case 'web': {
               if (!permissions_rune.value.push_notifications_permission.is_granted && permissions_rune.value.push_notifications_permission.attempted) return

               if (!permissions_rune.value.push_notifications_permission.is_granted) return await handlers.open_push_permissions_modal()
               push_notifications_state.init()

               break;
            }
            case 'android': {
               handlers.update_push_notifications_permission(true)
               push_notifications_state.init()
               return
            }
         }
      },

      open_push_permissions_modal: async () => {
         const PushPermission = (await import('../components/PushPermission.svelte'))
            .default;

         root_modal_state.open({
            component: PushPermission,
            props: { close_modal: root_modal_state.close },
            modal_props: { title: 'push_notifications_permissions' }
         });
      }

   };

   cap_utils.device
      .get_device_os()
      .then((value) => {
         if (value === 'android') handlers.update_push_notifications_permission(true);
      })
      .catch((error) => console.error({ error }));

   return {
      ...permissions_rune,
      ...handlers,
      get value() {
         return permissions_rune.value;
      },
      set value(value) {
         permissions_rune.value = value;
      },
      ...handlers
   };
}

export const permissions_state = permissions_state_fn();
